import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import BootstrapVue from "bootstrap-vue"
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/style.css"
import 'vue-awesome-notifications/dist/styles/style.css';
import VueAWN from 'vue-awesome-notifications'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueAWN, {position: "top-right", duration: 5000});


new Vue({
  render: h => h(App),
}).$mount('#app')
